import React, {useEffect, useState} from 'react';
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../Config/axios";

function Savings() {
    const [savings, setSavings] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        axios
            .get("savings/get")
            .then((res) => {
                let {code} = res.data;

                if (code === 200) {
                    setSavings(res?.data?.data?.savings);
                } else if (code === 400) {
                    setSavings(res?.data?.data?.savings);
                }
            })
            .catch(() => {
            });
    }, []);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
        };

        handleResize(); // Check initial width
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper/>}
            <Navbar activeLink='savings'/>
            <div className='wrapper'>

                <div className='home-title'>Хадгаламжийн төрлүүд</div>
                <div className={'savings-menu'}>
                    {savings.map((el, i) =>
                        <a key={i} href={`/savings/${el.id}`} className={'savings-menu-item'}>
                            {el.title}
                        </a>)
                    }

                </div>
                <Footer isMobile={isMobile}/>
            </div>
        </div>
    );
}

export default Savings;